import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    name: "JOHN",
  },
  reducers: {
    update: (state, action) => {
      state.name = action.payload.username;
    },
  },
});

export const { update } = userSlice.actions;
export default userSlice.reducer;
